import React, { Component, useState } from 'react'
import Navigation from '../../components/navigation/navigation'
import Footer from '../../components/footer/footer'
import Container from '../../components/container/container'
import request from '../../helpers/request'
import endpoints from '../../helpers/endpoints'
import { Redirect, Link, withRouter, matchPath } from 'react-router-dom'
import Card from '../../components/card/card'
import Modal from 'react-modal'
import Select from 'react-select'
import Pagination from '../../components/pagination/pagination'

export default withRouter(class CompanyPage extends Component {
    constructor(props) {
        super(props);


        this.state = {
            match: matchPath(props.history.location.pathname, {
                path: '/admin/portal/companies/:company'
            }),
            company: {
                id: null,
                name: null,
                subdomain: '',
                frontends: [],
                users: [],
                login_video_url: null,
                vaca_confirmation_screen: null,

                products: [],

                idle_timeout: 10,

                baa_select_match_webhook_url: null,
                baa_select_match_webhook_key: null,

                assurance_verification_webhook_url: null,
                assurance_verification_webhook_key: null,
                assurance_verification_updates_webhook_url: null,
                ms_non_addressables_assurance_verification_webhook_url: null,
                ms_non_addressables_assurance_verification_webhook_key: null,
                ms_non_addressables_assurance_verification_updates_webhook_url: null,
            },
            error: false,
            form: {},
            databases: [],
            buckets: [],
            new_user: {
                name: '',
                email: '',
            },
            wholesalers: [],
            selectedWholesaler: null,
            wholesalerConfig: {},
            enableDeleteField: false,
            errors: {},
            pagination: {
                page: 1,
                last_page: null
            },
            userSearch: '',
            userWholesaler: null,
        }
    }

    formSubmit = () => {
        request(true).post(endpoints.ADMIN_COMPANIES_COMPANY + '/' + this.state.match.params.company, {
            name: this.state.company.name,
            subdomain: this.state.company.subdomain ?? '',
            input_bucket: this.state.company.input_bucket,
            output_bucket: this.state.company.output_bucket,
            login_video_url: this.state.company.login_video_url,

            mds_upload_s3_bucket: this.state.company.mds_upload_s3_bucket,

            vaca_confirmation_screen: this.state.company.vaca_confirmation_screen,

            vacant_workflow_video_url: this.state.company.vacant_workflow_video_url,
            vacant_search_video_url: this.state.company.vacant_search_video_url,
            vacant_summary_video_url: this.state.company.vacant_summary_video_url,
            mosl_dqa_user_guide_video_url: this.state.company.mosl_dqa_user_guide_video_url,
            mosl_dqa_admin_guide_video_url: this.state.company.mosl_dqa_admin_guide_video_url,

            branding_configuration_id: this.state.company.branding_configuration_id,

            idle_timeout: this.state.company.idle_timeout,

            baa_select_match_webhook_url: this.state.company.baa_select_match_webhook_url,
            baa_select_match_webhook_key: this.state.company.baa_select_match_webhook_key,

            assurance_verification_webhook_url: this.state.company.assurance_verification_webhook_url,
            assurance_verification_webhook_key: this.state.company.assurance_verification_webhook_key,
            assurance_verification_updates_webhook_url: this.state.company.assurance_verification_updates_webhook_url,
            ms_non_addressables_assurance_verification_webhook_url: this.state.company.ms_non_addressables_assurance_verification_webhook_url,
            ms_non_addressables_assurance_verification_webhook_key: this.state.company.ms_non_addressables_assurance_verification_webhook_key,
            ms_non_addressables_assurance_verification_updates_webhook_url: this.state.company.ms_non_addressables_assurance_verification_updates_webhook_url,

            azure_tenant_id: this.state.company.azure_tenant_id,
            twilio_phone_number: this.state.company.twilio_phone_number,
        }).catch(e => {
            console.error(e);
        })
    }

    updateCompany = (args = {}, page) => {
        request(true).get(endpoints.ADMIN_COMPANIES_COMPANY + '/' + this.state.match.params.company + '?page=' + page, {
            doesCancel: true,
            params: {
                user_search: this.state.userSearch,
                user_wholesaler: this.state.userWholesaler?.value
            },
        }).then(e => {
            this.setState({
                company: {
                    ...this.state.company,
                    id: e.data.id,
                    name: e.data.name,
                    subdomain: e.data.subdomain,
                    users: e.data.users.data,
                    frontends: e.data.frontends,
                    login_video_url: e.data.login_video_url ?? "",

                    mds_upload_s3_bucket : e.data.mds_upload_s3_bucket ?? "",

                    vacant_summary_video_url: e.data.vacant_summary_video_url ?? "",
                    vacant_search_video_url: e.data.vacant_search_video_url ?? "",
                    vacant_workflow_video_url: e.data.vacant_workflow_video_url ?? "",

                    mosl_dqa_user_guide_video_url: e.data.mosl_dqa_user_guide_video_url ?? "",
                    mosl_dqa_admin_guide_video_url: e.data.mosl_dqa_admin_guide_video_url ?? "",

                    vaca_confirmation_screen: e.data.vaca_confirmation_screen ?? null,

                    branding_configuration_id: e.data.branding_configuration_id ?? null,

                    idle_timeout: e.data.idle_timeout || 10,

                    baa_select_match_webhook_url: e.data.baa_select_match_webhook_url ?? '',
                    baa_select_match_webhook_key: e.data.baa_select_match_webhook_key ?? '',

                    assurance_verification_webhook_url: e.data.assurance_verification_webhook_url ?? '',
                    assurance_verification_webhook_key: e.data.assurance_verification_webhook_key ?? '',
                    assurance_verification_updates_webhook_url: e.data.assurance_verification_updates_webhook_url ?? '',
                    ms_non_addressables_assurance_verification_webhook_url: e.data.ms_non_addressables_assurance_verification_webhook_url ?? '',
                    ms_non_addressables_assurance_verification_webhook_key: e.data.ms_non_addressables_assurance_verification_webhook_key ?? '',
                    ms_non_addressables_assurance_verification_updates_webhook_url: e.data.ms_non_addressables_assurance_verification_updates_webhook_url ?? '',

                    azure_tenant_id: e.data.azure_tenant_id ?? '',

                    ...args
                },
                pagination: {
                    page: e.data.users.current_page,
                    last_page: e.data.users.last_page
                },
                searchLoading: false,
            }, () => { console.log(this.state.company) })
        }).catch(e => {
            this.setState({ error: true});
        });
    }

    updateCompanyDB = (args = {}) => {
        request(true).get(endpoints.ADMIN_COMPANIES_COMPANY + '/' + this.state.match.params.company + '/db').then(e => {
            this.setState({
                databases: Object.assign({
                    contact_validation: {
                        host: '',
                        port: '',
                        database: '',
                        username: '',
                        password: '',
                    },
                    test: {
                        host: '',
                        port: '',
                        database: '',
                        username: '',
                        password: '',
                    },
                }, e.data)
            });
        }).catch(e => {
            window.alert('ERROR', e)
            console.error(e);
        });

        request(true).get(endpoints.ADMIN_COMPANIES_COMPANY + '/' + this.state.match.params.company + '/buckets').then(e => {
            this.setState({
                buckets: e.data
            });
        }).catch(e => {
            console.error(e);
        });
    }

    updateCompanyProducts = () => {
        request(true).get(endpoints.ADMIN_COMPANIES_COMPANY + '/' + this.state.match.params.company + '/products').then(r => {
            var productList = r.data.products;
            request(true).get(endpoints.PRODUCTS).then(r => {

                productList = productList.filter(item => r.data.find(product => product.id == item.id).available)

                productList = productList.map(item => ({
                    ...item,
                    icon: r.data.find(product => product.id == item.id).icon,
                    product_type: r.data.find(product => product.id == item.id).product_type,
                    order: r.data.find(product => product.id == item.id).order,
                }))

                if (!productList.find(product => product.product_key === "business_address_alert")) {
                    productList.push({product_key: 'business_address_alert', name: 'Business Address Alerts', disable_bucket: true, enabled: true})
                }
    
                this.setState({ company: {
                    ...this.state.company,
                    products: productList
                }});
            }).catch(e => {
                console.error(e);
            });
        }).catch(e => {
            console.error(e);
        });
    }

    getWholesalers() {
        request(true).get(endpoints.ADMIN_WHOLESALERS).then(r => {
            this.setState({wholesalers: r.data})
        }).catch(e => {
            console.log(e)
        })
    }

    componentDidMount() {
        this.updateCompany();
        this.updateCompanyDB();
        this.updateCompanyProducts();
        this.getWholesalers();
    }

    updateFormValue = (e) => {
        console.log(e.target.name, e.target.value, this.state.company[e.target.name])
        this.setState({
            company: {
                ...this.state.company,
                [e.target.name]: e.target.value ? e.target.value : null
            }
        })
    }

    updateProductSettings = (e) => {
        this.setState({
            company: {
                ...this.state.company,
                [e.target.name]: e.target.checked ? 1 : 0
            }
        })
    }

    updateDatabaseValue = (e) => {
        this.setState({
            database: {
                ...this.state.database,
                [e.target.name]: e.target.value ? e.target.value : undefined
            }
        })
    }

    updateProductChecked = (e) => {
        let products = [].concat(this.state.company.products);
        products.find(product => product.id == e.target.name).enabled = e.target.checked

        this.setState({ company: {
            ...this.state.company,
            products: products
        }});
    }

    databaseFormSubmit = (item) => {
        request(true).post(endpoints.ADMIN_COMPANIES_COMPANY + '/' + this.state.match.params.company + '/db', {
            product: item,
            database: this.state.databases[item]
        }).then(e => {
            window.alert(e.statusText)
            //console.log(e);
        }).catch(e => {
            window.alert(e.statusText)
            console.error(e);
        });
    }

    bucketFormSubmit = (item) => {
        request(true).post(endpoints.ADMIN_COMPANIES_COMPANY + '/' + this.state.match.params.company + '/buckets', {
            product: item,
            bucket: this.state.buckets[item]
        }).then(e => {
            //console.log(e);
        }).catch(e => {
            console.error(e);
        });
    }

    productFormSubmit = () => {
        let data = this.state.company.products.filter(item => {
            return item.id && item.enabled;
        }).map(item => {
            return item.id;
        });

        request(true).post(endpoints.ADMIN_COMPANIES_COMPANY + '/' + this.state.match.params.company + '/products', { products: data }).then(r => {
            console.log(r);
        }).catch(e => {
            console.error(e);
        })

    }

    wholsalerConfigSubmit = () => {
        const wholesalerId = this.state.wholesalers.find(wholesaler => wholesaler.Name === this.state.selectedWholesaler?.value)?.id
        request(true).post(endpoints.ADMIN_WHOLESALERS + `/${wholesalerId}`, { ...this.state.wholesalerConfig }).then(r => {
            console.log(r);
            this.setState({wholesalers: this.state.wholesalers.map(wholesaler => {
                return wholesaler.id === wholesalerId ? r.data : wholesaler 
            })})
        }).catch(e => {
            console.error(e);
        })
    }

    updateNewUserFormValue = (e) => {
        this.setState({
            new_user: {
                ...this.state.new_user,
                [e.target.name]: e.target.value ? e.target.value : undefined
            }
        })
    }

    newUserFormSubmit = () => {
        request(true).post(endpoints.ADMIN_COMPANIES_USER, {
            ...this.state.new_user,
            company_id: this.state.company.id
        }).then(r => {
            this.updateCompany();
            this.setState({
                new_user: { name: '', email: '' }
            });
            this.props.history.push(`/admin/portal/users/${r.data.user_id}`);
        }).catch(r => {
            if(r.response.data.error == "User email already in use") {
                window.alert("User email already in use");
                this.setState({
                    new_user: { name: '', email: '' }
                });
            } else {
                this.setState({
                    errors: r.response.data.errors
                });
            }
        });
    }

    deleteFrontend = id => {
        let url = endpoints.ADMIN_COMPANIES_COMPANY_FRONTEND + '/' + id;
        request(true).delete(url).then(r => {
            this.updateCompany();
        }).catch(r => {
            //console.log(r.response);
        });
    }

    createFrontend = () => {
        let url = endpoints.ADMIN_COMPANIES_COMPANY_FRONTEND;
        //console.log(this.state.company);
        request(true).post(url, {
            company_id: this.state.company.id,
            frontend_url: this.state.company.new_frontend
        }).then(r => {
            this.updateCompany({ new_frontend: "", errors: {} });
        }).catch(r => {
            //console.log(r.response);
        });
    }

    closeModal = () => {
        this.setState({
            modalIsOpen: false,
        })
    }

    openModal = () => {
        this.setState({
            modalIsOpen: true,
        })
    }

    deleteCompany = () => {
        if (this.state.enableDeleteField) {
            request(true).delete(endpoints.ADMIN_COMPANIES_COMPANY + '/' + this.state.match.params.company).then(r => {
                this.props.history.push('admin/portal/companies');
            }).catch(r => {
                console.error(r);
            });
        } else {
            this.setState({
                enableDeleteField: true
            });
        }
    }

    render() {
        return this.state.error ?
            <Redirect to="/admin/portal/companies"/>
        :
            <div className="grid grid-gap-20" id="company-page">
                <Navigation />
                <Container>
                    <div className="flex middle">
                        <p className="colour-secondary font-weight-600" style={{fontSize: 20}}>{ this.state.company.name }</p>
                    </div>
                </Container>
                <Container>
                    { this.state.company.id !== null ?
                        <>
                            <Card>
                                <div className="grid grid-gap-15">
                                    <div className="flex middle">
                                        <p className="colour-secondary font-weight-600" style={{fontSize: 20}}><i className="fad fa-info-square"></i> Basic Information</p>
                                    </div>
                                    <div className="grid grid-columns-2 grid-gap-15">
                                        <div className="form-row">
                                            <label htmlFor="name">Company Name:</label>
                                            <input onChange={this.updateFormValue} name="name" placeholder="Name" className="input" type="text" value={this.state.company.name} required/>
                                        </div>
                                        <div className="form-row">
                                            <label htmlFor="subdomain">Company Subdomain:</label>
                                            <input onChange={this.updateFormValue} name="subdomain" placeholder="Subdomain" className="input" type="text" value={this.state.company.subdomain} required/>
                                        </div>
                                        <div className="form-row">
                                            <label htmlFor="branding_configuration_id">Branding Configuration ID:</label>
                                            <input onChange={this.updateFormValue} name="branding_configuration_id" placeholder="Brand ID" className="input" type="text" value={this.state.company.branding_configuration_id} required/>
                                        </div>
                                        <div className="form-row">
                                            <label htmlFor="idle_timeout">Idle Timeout (Minutes):</label>
                                            <input onChange={this.updateFormValue} name="idle_timeout" placeholder="Idle Timeout" className="input" type="number" min={1} value={this.state.company.idle_timeout} required/>
                                        </div>
                                        <div className="form-row">
                                            <label htmlFor="azure_tenant_id">Azure Tenant ID</label>
                                            <input onChange={this.updateFormValue} name="azure_tenant_id" placeholder="Azure Tenant ID" className="input" type="text" value={this.state.company.azure_tenant_id} required/>
                                        </div>
                                    </div>
                                    <div className="flex middle">
                                        <p className="colour-secondary font-weight-600" style={{fontSize: 20}}><i className="fad fa-box"></i> Company Specific Buckets</p>
                                    </div>
                                    <div className="grid grid-columns-2 grid-gap-15">
                                        { this.state.company.products.find(product => ['portfolio_summary', 'business_address_alert'].includes(product.product_key) && product.enabled) ?
                                            <>
                                                <div className="form-row">
                                                    <label htmlFor="mds_upload_s3_bucket">MDS Upload Bucket</label>
                                                    <input onChange={this.updateFormValue} name="mds_upload_s3_bucket" placeholder="MDS Upload Bucket Name" className="input" type="text" value={this.state.company.mds_upload_s3_bucket}/>
                                                </div>                            
                                            </>
                                            :
                                            <></>
                                        }
                                    </div>
                                    <div className="flex middle">
                                        <p className="colour-secondary font-weight-600" style={{fontSize: 20}}><i className="fad fa-link"></i> Webhooks</p>
                                    </div> 
                                    <div className="grid grid-columns-2 grid-gap-15">
                                        <div className="form-row">
                                            <label htmlFor="assurance_verification_webhook_url">Assurance Verification URL:</label>
                                            <input onChange={this.updateFormValue} name="assurance_verification_webhook_url" placeholder="Assurance Verification URL" className="input" type="text" value={this.state.company.assurance_verification_webhook_url} required/>
                                        </div>
                                        <div className="form-row">
                                            <label htmlFor="assurance_verification_webhook_key">Assurance Verification Key:</label>
                                            <input onChange={this.updateFormValue} name="assurance_verification_webhook_key" placeholder="Assurance Verification Key" className="input" type="text" value={this.state.company.assurance_verification_webhook_key} required/>
                                        </div>
                                        <div className="form-row">
                                            <label htmlFor="assurance_verification_updates_webhook_url">Assurance Verification Updates URL:</label>
                                            <input onChange={this.updateFormValue} name="assurance_verification_updates_webhook_url" placeholder="Assurance Verification Updates URL" className="input" type="text" value={this.state.company.assurance_verification_updates_webhook_url} required/>
                                        </div>
                                        <div></div>
                                        <div className="form-row">
                                            <label htmlFor="ms_non_addressables_assurance_verification_webhook_url">MS Non Addressables Assurance Verification URL:</label>
                                            <input onChange={this.updateFormValue} name="ms_non_addressables_assurance_verification_webhook_url" placeholder="MS Non Addressables Assurance Verification URL" className="input" type="text" value={this.state.company.ms_non_addressables_assurance_verification_webhook_url}/>
                                        </div>
                                        <div className="form-row">
                                            <label htmlFor="ms_non_addressables_assurance_verification_webhook_key">MS Non Addressables Assurance Verification Key:</label>
                                            <input onChange={this.updateFormValue} name="ms_non_addressables_assurance_verification_webhook_key" placeholder="MS Non Addressables Assurance Verification Key" className="input" type="text" value={this.state.company.ms_non_addressables_assurance_verification_webhook_key}/>
                                        </div>
                                        <div className="form-row">
                                            <label htmlFor="ms_non_addressables_assurance_verification_updates_webhook_url">MS Non Addressables Assurance Verification Updates URL:</label>
                                            <input onChange={this.updateFormValue} name="ms_non_addressables_assurance_verification_updates_webhook_url" placeholder="MS Non Addressables Assurance Verification Updates URL" className="input" type="text" value={this.state.company.ms_non_addressables_assurance_verification_updates_webhook_url}/>
                                        </div>
                                        <div></div>
                                    </div>
                                    <div className="flex middle">
                                        <p className="colour-secondary font-weight-600" style={{fontSize: 20}}><i className="fad fa-video"></i> Platform Videos</p>
                                    </div>
                                    <div className="grid grid-columns-2 grid-gap-15">
                                        <div className="form-row">
                                            <label htmlFor="login_video_url">Login Video URL:</label>
                                            <input onChange={this.updateFormValue} name="login_video_url" placeholder="Login Video URL" className="input" type="text" value={this.state.company.login_video_url} required/>
                                        </div>
                                    </div>

                                    { this.state.company.products.length && this.state.company.products.find(product => product.product_key == 'vacant_cot_alerts' && product.enabled) ?
                                        <>
                                            <div className="flex middle">
                                                <p className="colour-secondary font-weight-600" style={{fontSize: 20}}><i className="fad fa-video"></i> Vacant COT Alerts Videos</p>
                                            </div>
                                            <div className="grid grid-columns-2 grid-gap-15">
                                                {/* Vacant */}
                                                <div className="form-row">
                                                    <label htmlFor="vacant_summary_video_url">Vacant COT Alerts Summary Video URL:</label>
                                                    <input onChange={this.updateFormValue} name="vacant_summary_video_url" placeholder="Vacant Summary Video URL" className="input" type="text" value={this.state.company.vacant_summary_video_url} required/>
                                                </div>
                                                <div className="form-row">
                                                    <label htmlFor="vacant_search_video_url">Vacant COT Alerts Search Video URL:</label>
                                                    <input onChange={this.updateFormValue} name="vacant_search_video_url" placeholder="Vacant Search Video URL" className="input" type="text" value={this.state.company.vacant_search_video_url} required/>
                                                </div>
                                                <div className="form-row">
                                                    <label htmlFor="vacant_workflow_video_url">Vacant COT Alerts Workflow Video URL:</label>
                                                    <input onChange={this.updateFormValue} name="vacant_workflow_video_url" placeholder="Vacant Workflow Video URL" className="input" type="text" value={this.state.company.vacant_workflow_video_url} required/>
                                                </div>
                                            </div>
                                        </>
                                        :
                                        <></>
                                    }

                                    { this.state.company.products.length && this.state.company.products.find(product => product.product_key == 'mosl_dqa' && product.enabled) ?
                                        <>
                                            <div className="flex middle">
                                                <p className="colour-secondary font-weight-600" style={{fontSize: 20}}><i className="fad fa-video"></i> MOSL DQA Videos</p>
                                            </div>
                                            <div className="grid grid-columns-2 grid-gap-15">
                                                <div className="form-row">
                                                    <label htmlFor="mosl_dqa_user_guide_video_url">MOSL DQA User Guide Video URL:</label>
                                                    <input onChange={this.updateFormValue} name="mosl_dqa_user_guide_video_url" placeholder="MOSL DQA User Guide Video URL" className="input" type="text" value={this.state.company.mosl_dqa_user_guide_video_url} required/>
                                                </div>
                                                <div className="form-row">
                                                    <label htmlFor="mosl_dqa_admin_guide_video_url">MOSL DQA Admin Guide Video URL:</label>
                                                    <input onChange={this.updateFormValue} name="mosl_dqa_admin_guide_video_url" placeholder="MOSL DQA Admin Guide Video URL" className="input" type="text" value={this.state.company.mosl_dqa_admin_guide_video_url} required/>
                                                </div>
                                            </div>
                                        </>
                                        :
                                        <></>
                                    }

                                    <div className="grid grid-columns-2 grid-gap-15">
                                        <button onClick={this.formSubmit} className="button background-primary colour-white">Update</button>
                                        <Link style={{ textAlign: 'center', textDecoration: 'none' }} class="button background-primary colour-white" to={ `/admin/portal/companies/${this.state.match.params.company}/translate`}>Translations</Link>
                                    </div>
                                </div>
                            </Card>

                            <div className="flex middle">
                                <p className="colour-secondary font-weight-600" style={{fontSize: 20}}><i class="fa-solid fa-water"/> Wholesaler Configuration</p>
                            </div>
                            <Card>
                                <div style={{ width: '50%' }}>
                                    <label htmlFor="wholesaler">Selected Wholesaler:</label>
                                    <Select 
                                        name='wholesaler' 
                                        onChange={(selected) => this.setState({selectedWholesaler: selected, wholesalerConfig: this.state.wholesalers.find(wholesaler => wholesaler.Name === selected.value) ?? {}})} 
                                        value={this.state.selectedWholesaler} 
                                        options={this.state.wholesalers.map(wholesaler => {
                                            return {label: wholesaler.Label, value: wholesaler.Name}
                                        })}  
                                    />
                                </div>
                                <div class="grid grid-columns-2 grid-gap-15">
                                    <div className="form-row">
                                        <label htmlFor="mds_upload_s3_bucket">MDS Upload Bucket</label>
                                        <input onChange={(event) => this.setState({wholesalerConfig: {...this.state.wholesalerConfig, Input_Bucket: event.target.value}})} name="wholesaler_input_bucket" placeholder="Upload Bucket Name" className="input" type="text" value={this.state.wholesalerConfig?.Input_Bucket ?? ''}/>
                                    </div>
                                </div>
                                <div class="grid grid-columns-2 grid-gap-15" style={{ marginTop: '1em' }}>
                                    <button onClick={this.wholsalerConfigSubmit} className="button background-primary colour-white">Update</button>
                                </div>
                            </Card>

                            <div className="flex middle">
                                <p className="colour-secondary font-weight-600" style={{fontSize: 20}}>Product Configuration</p>
                            </div>

                            <div className="grid grid-gap-15">

                                <Card>
                                    <div className="grid grid-columns-2 grid-gap-15" style={{marginBottom: 10}}>

                                        { this.state.company.products.filter(item => item.product_type === "Address Portal").length ? 
                                            <div>
                                                <h3>Address Portal</h3>
                                                { this.state.company.products.filter(item => item.product_type === "Address Portal").map((item, index) => {
                                                    return (
                                                        <div className="item" key={`product-${item.id}`}>
                                                            { item.name }: <input type="checkbox" name={ item.id } onChange={ this.updateProductChecked } checked={ item.enabled }/>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        : null }

                                        { this.state.company.products.filter(item => item.product_type === "MOSL").length ? 
                                            <div>
                                                <h3>MOSL</h3>
                                                { this.state.company.products.filter(item => item.product_type === "MOSL").map((item, index) => {
                                                    return (
                                                        <div className="item" key={`product-${item.id}`}>
                                                            { item.name }: <input type="checkbox" name={ item.id } onChange={ this.updateProductChecked } checked={ item.enabled }/>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        : null }

                                    </div>
                                    <div class="grid grid-columns-2 grid-gap-15">
                                        <button onClick={ this.productFormSubmit } className="button background-primary colour-white">Update</button>
                                    </div>

                                    <div className="grid grid-columns-2 grid-gap-15" style={{marginBottom: 10}}>
                                        <div>
                                            <h3>Product Settings</h3>
                                            <div>
                                                <div>VaCA Confirmation Screen: <input type="checkbox" name="vaca_confirmation_screen" onChange={ this.updateProductSettings } checked={ this.state.company ? this.state.company.vaca_confirmation_screen : false}></input></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="grid grid-columns-2 grid-gap-15">
                                        <button onClick={this.formSubmit} className="button background-primary colour-white">Update</button>
                                    </div>
                                </Card>

                                <div className="flex middle">
                                    <p className="colour-secondary font-weight-600" style={{fontSize: 20}}>Product Databases</p>
                                </div>

                                <div className="grid grid-columns-3 grid-gap-15">
                                    { this.state.company.products.filter(product => product.enabled && product.product_key !== "uprn_search").map((item, index) => {
                                        if (!item) { return null };

                                        const updateDatabaseState = (event) => {
                                            this.setState({ databases: {
                                                ...this.state.databases,
                                                [item.product_key]: {
                                                    ...this.state.databases[item.product_key],
                                                    [event.target.name]: event.target.value
                                                }
                                            }}, () => {
                                                //console.log(this.state.databases);
                                            })
                                        }

                                        const updateBucketState = (event) => {
                                            this.setState({ buckets: {
                                                ...this.state.buckets,
                                                [item.product_key]: {
                                                    ...this.state.buckets[item.product_key],
                                                    [event.target.name]: event.target.value
                                                }
                                            }}, () => {
                                                //console.log(this.state.buckets);
                                            })
                                        }

                                        return (
                                            <Card key={ `product-${item.product_key}` } className="slim">
                                                <div className="title">
                                                    { item.name }
                                                </div>
                                                <div className="grid grid-columns-1 grid-gap-15">
                                                    <div className="grid grid-gap-15">
                                                        <div className="form-row">
                                                            <label htmlFor="host">Database Host:</label>
                                                            <input onChange={updateDatabaseState} name="host" placeholder="Host" className="input slim" type="password" value={(this.state.databases[item.product_key] ?? {}).host} required/>
                                                        </div>
                                                        <div className="form-row">
                                                            <label htmlFor="port">Database Port:</label>
                                                            <input onChange={updateDatabaseState} name="port" placeholder="Port" className="input slim" type="number" value={(this.state.databases[item.product_key] ?? {}).port} required/>
                                                        </div>
                                                        <div className="form-row">
                                                            <label htmlFor="database">Database Name:</label>
                                                            <input onChange={updateDatabaseState} name="database" placeholder="Database" className="input slim" type="text" value={(this.state.databases[item.product_key] ?? {}).database} required/>
                                                        </div>
                                                        <div className="form-row">
                                                            <label htmlFor="username">Database User:</label>
                                                            <input onChange={updateDatabaseState} name="username" placeholder="User" className="input slim" type="text" value={(this.state.databases[item.product_key] ?? {}).username} required/>
                                                        </div>
                                                        <div className="form-row">
                                                            <label htmlFor="password">Database Password:</label>
                                                            <input onChange={updateDatabaseState} name="password" placeholder="Password" className="input slim" type="password" value={(this.state.databases[item.product_key] ?? {}).password} required/>
                                                        </div>
                                                        <button onClick={ () => this.databaseFormSubmit(item.product_key) } className="button background-primary colour-white">Update</button>
                                                    </div>
                                                    { item.disable_bucket !== true ?
                                                        <div className="grid grid-gap-15" style={{ height: 'fit-content' }}>
                                                            <div className="form-row">
                                                                <label htmlFor="input_bucket">Input Bucket:</label>
                                                                <input onChange={updateBucketState} name="input_bucket" placeholder="Input Bucket" className="input slim" type="text" value={(this.state.buckets[item.product_key] ?? {}).input_bucket} required/>
                                                            </div>
                                                            <div className="form-row">
                                                                <label htmlFor="output_bucket">Output Bucket:</label>
                                                                <input onChange={updateBucketState} name="output_bucket" placeholder="Output Bucket" className="input slim" type="text" value={(this.state.buckets[item.product_key] ?? {}).output_bucket} required/>
                                                            </div>
                                                            <button onClick={ () => this.bucketFormSubmit(item.product_key) } className="button background-primary colour-white">Update</button>
                                                        </div>
                                                    : '' }
                                                </div>
                                            </Card>
                                        )
                                    }) }
                                </div>
                            </div>

                            <div className="grid grid-columns-2 grid-gap-15 margin-top-25">

                            <div>
                                <div className="flex middle">
                                    <p className="colour-secondary font-weight-600" style={{fontSize: 20}}>Frontend URLs</p>
                                </div>
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th>URL</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            { this.state.company.frontends.map(subdomain => {
                                                return (
                                                    <tr key={ subdomain.id }>
                                                        <td>{ subdomain.frontend_url }</td>
                                                        <td className="actions"><span onClick={ () => this.deleteFrontend(subdomain.id) }><i className="fas fa-minus-circle"/></span></td>
                                                    </tr>
                                                );
                                            })}
                                            <tr>
                                                <td>
                                                    <input onChange={this.updateFormValue} name="new_frontend" placeholder="Frontend URL" className="input" type="text" value={this.state.company.new_frontend} required/>
                                                </td>
                                                <td className="actions">
                                                    <span onClick={ this.createFrontend }><i className="fas fa-plus-circle"></i></span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <div>
                                    <div className="flex middle" style={{ justifyContent: 'space-between' }}>
                                        <p className="colour-secondary font-weight-600" style={{fontSize: 20}}>
                                            Company Users
                                        </p>
                                        <Select 
                                            name='wholesaler-search'
                                            styles={{ 
                                                container: (baseStyles, state) => ({
                                                    ...baseStyles,
                                                    width: '50%',
                                                  }),
                                            }}
                                            onChange={(selected) => this.setState({userWholesaler: selected, searchLoading: true}, this.updateCompany)} 
                                            value={this.state.userWholesaler} 
                                            options={[{label: 'All Wholesalers', value: ''}].concat(this.state.wholesalers.map(wholesaler => {
                                                return {label: wholesaler.Label, value: wholesaler.Name}
                                            }))}
                                        />
                                    </div>

                                    <table className="table" style={{ tableLayout: 'fixed' }}>
                                        <thead>
                                            <tr>
                                                <th style={{ width: '50%' }}>Email Address</th>
                                                <th style={{ width: '50%' }}>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                this.state.searchLoading ?
                                                    <tr>
                                                        <td colSpan={'100%'}>
                                                            <i className="fa fa-spinner fa-spin" />
                                                        </td>
                                                    </tr>
                                                :
                                                    this.state.company.users.map(user => {
                                                        return (
                                                            <tr key={ user.id }>
                                                                <td>{ user.name }</td>
                                                                <td className="actions"><Link to={ "/admin/portal/users/" + user.id }><i className="fa fa-search" aria-hidden="true"></i></Link></td>
                                                            </tr>
                                                        );
                                                    })
                                            }
                                            <tr>
                                                <td>
                                                    <button onClick={this.openModal} className="button background-primary colour-white">Add A User</button>
                                                </td>
                                                <td style={{ paddingLeft: 0, paddingRight: '2em' }} >
                                                    <input onChange={(event) => this.setState({userSearch: event.target.value, searchLoading: true}, () => this.updateCompany())} placeholder="Search Email" className="input" type="text" value={this.state.userSearch} />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        {
                                            this.state.pagination.last_page > 1 && !this.state.searchLoading &&
                                                <Pagination page={this.state.pagination.page} pages={this.state.pagination.last_page} pageChange={(page) => this.updateCompany({}, page)}/>
                                        }
                                    </div>

        
        </div>
                            </div>
                            <div className={ this.state.enableDeleteField ? 'delete enabled' : 'delete disabled'} style={{ textAlign: 'center', marginTop: '40px' }}>
                                <button onClick={this.deleteCompany} className="button background-red colour-white">
                                    <span style={{ marginRight: '20px' }}>{ this.state.enableDeleteField ? 'Are you sure?' : 'Delete This Company' }</span>
                                    <i className="fa fa-unlock" aria-hidden="true"></i>
                                    <i className="fa fa-lock" aria-hidden="true"></i>
                                </button>
                            </div>
                        </>
                    : <></>
                    }
                </Container>
                <Modal
                        style={{ overlay: { backgroundColor: 'rgba(14, 14, 14, 0.55)' } }}
                        className="card"
                        isOpen={this.state.modalIsOpen}
                        onRequestClose={this.closeModal}
                        contentLabel="Add A User"
                        appElement={document.getElementById('company-page')}
                    >
                    <div className="grid grid-gap-15">
                            <div className="form-row">
                                <label htmlFor="name">Name:</label>
                                <input onChange={this.updateNewUserFormValue} name="name" placeholder="Name" className="input" type="text" value={this.state.new_user ? this.state.new_user.name : ''} required/>
                                { this.state.errors.name ? this.state.errors.name.map((value, index) => {
                                    return (
                                        <p key={index}>
                                            { value }
                                        </p>
                                    )
                                }) : <></>}
                            </div>
                            <div className="form-row">
                                <label htmlFor="email">Email:</label>
                                <input onChange={this.updateNewUserFormValue} name="email" placeholder="Email" className="input" type="text" value={this.state.new_user.email} required/>
                                { this.state.errors.email ? this.state.errors.email.map((value, index) => {
                                    return (
                                        <p className="error" key={index}>
                                            { value }
                                        </p>
                                    )
                                }) : <></>}
                            </div>
                            <button onClick={this.newUserFormSubmit} className="button background-primary colour-white">Create</button>
                            <p className="text-center">{ this.state.message }</p>
                        </div>
                    </Modal>
                <Footer />
            </div>;
    }
})
